import AgreementAndRelease from './AgreementAndRelease';

export default AgreementAndRelease;
